import styled from "@emotion/styled";
import { css } from "@emotion/react";

export const JobSeekersPage = styled.main`
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {},
  })}
`;

export const JobGuidBox = styled.div`
  background: #ffffff;
  border: 1px solid #e6e6e7;
  border-radius: 15px;
  padding: 40px 30px;
  max-width: 300px;
  min-height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  transition: all 250ms ease-in-out;
  cursor: pointer;
  &:hover {
    box-shadow: 0 0 10px 0 #8d8e91;
  }
  .icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    background: #17479e;
    border-radius: 10px;
    width: 50px;
    height: 50px;
  }
  .title {
    font-weight: 500;
    font-size: 15px;
    line-height: 26px;
    color: #000000;
    margin-bottom: 10px;
  }
  .subTitle {
    font-weight: 400;
    font-size: 13px;
    line-height: 24px;
    color: #808285;
  }
`;

export const RecruitmentProcess = styled.div`
  background: #fcfcfc;
  padding: 90px 0 140px;
  h2 {
    text-align: center;
    font-weight: 500;
    font-size: 20px;
    line-height: 40px;
    color: #000000;
    margin-bottom: 80px;
  }
  .timeLine {
    position: relative;
    overflow: hidden;
    &::before {
      content: " ";
      position: absolute;
      border-style: dashed;
      border-color: #e6e6e7;
      border-left-width: 0;
      height: 100%;
      z-index: 1;
      right: 50%;
    }
    .item {
      position: relative;
      display: flex;
      flex-direction: column;
      max-width: 550px;
      i {
        display: inline-block;
        width: 45px;
        height: 45px;
        align-items: center;
        justify-content: flex-start;
      }
      h3 {
        font-weight: 500;
        font-size: 16px;
        line-height: 28px;
        color: #000000;
        margin-bottom: 15px;
      }
      p {
        font-weight: 400;
        font-size: 14px;
        line-height: 32px;
        color: #808285;
      }

      // dot style
      &::before {
        content: " ";
        position: absolute;
        width: 10px;
        height: 10px;
        background-color: #17479e;
        border-width: 7px;
        border-style: solid;
        border-color: #d3daeb;
        box-sizing: content-box;
        border-radius: 50%;
        z-index: 1;
      }
      &:nth-of-type(odd) {
        margin-right: auto;
        margin-left: 0;
      }
      &:nth-of-type(even) {
        margin-left: auto;
        margin-right: 0;
      }
      &:nth-of-type(even)::before {
        left: -48px;
      }
      &:nth-of-type(odd)::before {
        right: -45px;
      }
    }
  }

  @media screen and (max-width: 1220px) {
    .timeLine {
      max-width: 830px;
      margin: 0 auto;
      .item {
        max-width: 381px;
      }
    }
  }
  @media screen and (max-width: 900px) {
    .timeLine {
      max-width: 100%;
      &::before {
        left: 12px;
        right: unset;
      }
      .item {
        max-width: 100%;
        padding-bottom: 40px;
        &:nth-of-type(odd),
        &:nth-of-type(even) {
          margin-left: 50px;
          margin-right: 0;
        }
        &:nth-of-type(even)::before {
          left: -48px;
          right: unset;
        }
      }
    }
  }
`;

export const JobPositionsPage = styled.div`
  .mainTitle {
    font-weight: 600;
    font-size: 18px;
    line-height: 32px;
    color: #000000;
  }
  .title {
    font-weight: 700;
    font-size: 20px;
    line-height: 40px;
    color: #17479e;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    text-align: right;
    i {
      display: flex;
      align-items: center;
      margin-right: 10px;
      svg path {
        fill: #17479e;
      }
    }
  }
  p {
    ${props =>
      props.locale === "fa"
        ? css`
            text-align: right;
          `
        : ""}
  }
  figure {
    margin-inline: 0;
  }
  .MuiDivider-root {
    width: 100%;
    margin-block: 60px;
    &:last-child {
      display: none;
    }
  }
`;
